import { isRejectedWithValue, Middleware } from '@reduxjs/toolkit';
import airflowApi from './airflowSlice';
import { throwErrorToast } from 'utils';
import { errorMessages } from 'constants/messages';

export const airflowApiQueryErrorLogger: Middleware = () => next => action => {
    if (action.type.split('/')[0] === airflowApi.reducerPath && isRejectedWithValue(action)) {
        const details = action?.payload?.data?.detail;

        const errorMessage = (errorCode: number) => (details ? details : errorMessages[errorCode]);
        switch (action?.payload?.originalStatus || action?.payload?.status) {
            case 400:
                console.warn(`Type: ${action?.type}`);
                console.warn(`We got a rejected action in API! (ERROR CODE 400) - ${action?.meta?.arg?.endpointName}`);
                console.warn(action?.payload);
                throwErrorToast({
                    message: errorMessage(400),
                    action,
                    errorCode: 400,
                });
                break;

            case 401:
                console.warn(`Type: ${action.type}`);
                console.warn(`We got a rejected action in API! (ERROR CODE 401) - ${action.meta.arg.endpointName}`);
                console.warn(action.payload);
                break;

            case 403:
                console.warn(`Type: ${action.type}`);
                console.warn(`We got a rejected action in API! (ERROR CODE 403) - ${action.meta.arg.endpointName}`);
                console.warn(action.payload);
                break;

            case 404:
                console.warn(`Type: ${action.type}`);
                console.warn(`We got a rejected action in API! (ERROR CODE 404) - ${action.meta.arg.endpointName}`);
                console.warn(action.payload);
                throwErrorToast({
                    message: errorMessage(404),
                    action,
                    errorCode: 404,
                });
                break;

            case 409:
                console.warn(`Type: ${action.type}`);
                console.warn(`We got a rejected action in API! (ERROR CODE 409) - ${action.meta.arg.endpointName}`);
                console.warn(action.payload);
                throwErrorToast({
                    message: errorMessage(409),
                    action,
                    errorCode: 409,
                });
                break;

            default:
                console.warn(`Type: ${action.type}`);
                console.warn(`Internal API ERROR! (500) - ${action.meta.arg.endpointName}`);
                console.warn(action.payload);
                throwErrorToast({
                    message: errorMessage(500),
                    action,
                    errorCode: 500,
                });
                break;
        }
    }

    return next(action);
};
